import React from "react";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";

const InitialsField = (props) => {
  let { required, label } = props;

  if (required === undefined) {
    required = false;
  }

  const isValid = (x) => {
    const re = /^[ "&-.0-:A-Za-z]{1,4}$/;
    return (x || !required) &&
      (re.test(x) || (!required && (x === undefined || x?.length === 0)))
      ? undefined
      : "Please enter valid initials";
  };

  return (
    <Field
      name="initials"
      validate={isValid}
      label={label}
      // autoComplete="initials"
      required={required}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      fullWidth
      inputProps={{ maxLength: 4 }}
    />
  );
};

export default InitialsField;
